import { createSelector } from '@reduxjs/toolkit';
import { selectCompletionYearValue } from './selectCompletionYearValue';
import { AVAILABLE_COMPLETION_YEAR_TYPES, CURRENT_YEAR } from './constants';
import { ECompletionYearType } from '../../../../packages/JsonQuery';

export const selectCompletionYearFilter = createSelector(selectCompletionYearValue, value => {
  const yearOptions = AVAILABLE_COMPLETION_YEAR_TYPES.map(value => ({
    label: String(CURRENT_YEAR + (value as number)),
    value,
  }));

  const options = [
    { label: 'Неважно', value: null },
    { label: 'Сдан', value: ECompletionYearType.HandedOver },
    ...yearOptions,
    { label: 'Позднее', value: ECompletionYearType.Later },
  ];

  return {
    label: 'Год сдачи ЖК',
    value,
    options,
    yearOffset: CURRENT_YEAR,
    availableCompletionYearTypes: AVAILABLE_COMPLETION_YEAR_TYPES,
  };
});
